<template>
    <div>
      <CRow class="mb-3 search-panel">
        <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
          <label>Thao tác</label>
          <div class="dropdown btn-group" style="height: 36px;">
            <button class="btn">
              <div class="group-checkbox">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" v-model="actionData.model.selectedAll"
                    @change="changeSelectAll" id="selectedAll" />
                  <label class="custom-control-label" for="selectedAll"></label>
                </div>
              </div>
            </button>
            <button type="button" class="dropdown-toggle dropdown-toggle-split btn" data-toggle="dropdown"
              aria-expanded="false" aria-haspopup="true"></button>
            <div class="dropdown-menu">
              <button :disabled="actionData.model.listSelectedId.length === 0" class="dropdown-item"
                @click="setupSelectOneAction('delete_list')" color="danger">
                <CIcon name="cil-trash" style="danger" class="mr-2" />
                Xóa tất cả
              </button>
            </div>
          </div>
        </CCol>
        <CCol sm="2" xs="12">
          <BaseInput :options="codeInput.options" :data="codeInput.data" :listener="codeInput.listener" />
        </CCol>
        <CCol sm="2" xs="12">
          <BaseInput :options="nameInput.options" :data="nameInput.data" :listener="nameInput.listener" />
        </CCol>
        <CCol>
          <div class="form-group">
            <label style="color: white"></label>
            <div style="margin-top: 10px">
              <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tải lại'"
                class="btn-action-primary" @click="loadDataMainTable(true)">
                <i class="fa fa-refresh"></i>&nbsp;&nbsp;Tải lại
              </CButton>
              <CButton style="float: right;" color="primary" v-c-tooltip.hover="'Tạo mới'" class="btn-action-primary"
                @click="$router.push('/product-management/create.html')">
                <i class="fa fa-plus"></i>&nbsp;Tạo mới
              </CButton>
            </div>
          </div>
        </CCol>
      </CRow>
      <CCard class="content-fade-in mt-3p5">
        <CCardBody>
          <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
            @row-click="rowClickTable($event)" ref="mainTable">
            <template #checkbox="{ item }">
              <td class="group-checkbox">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" v-model="actionData.model.listSelectedId"
                    :value="item.id" :id="item.id" v-c-tooltip.hover="'Selected'" />
                  <label class="custom-control-label" :for="item.id"></label>
                </div>
              </td>
            </template>
  
            <template #createDate="{ item }">
              <td>
                {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
              </td>
            </template>
            <template #quantity="{ item }">
              <td v-if="item.quantity">
                <span v-model="item.quantity"></span>
              </td>
              <td v-else>
                <span></span>
              </td>
            </template>
            <template #action="{ item }">
              <td class="action-btn-group">
                <div class="action-btn-wrapper">
                  <CButton color="info" variant="outline" v-c-tooltip.hover="'Kiểm tra tồn kho'" square size="sm"
                    @click="checkQuantity(item)">
                    <CIcon name="cil-reload" />
                  </CButton>
                  <CButton color="info" variant="outline" v-c-tooltip.hover="'Cập nhật'" square size="sm"
                    @click="$router.push(`/product-management/${item.id}/update.html`)">
                    <CIcon name="cil-pencil" />
                  </CButton>
                  <CButton color="danger" variant="outline" class="ml-1" square size="sm" v-c-tooltip.hover="'Xóa'" @click="
                    setupSelectOneAction('delete_one', item.id, item.code, item.name)
                    ">
                    <CIcon name="cil-trash" />
                  </CButton>
                </div>
              </td>
            </template>
          </BaseTable>
          <BaseLoading :loading="loading.value"></BaseLoading>
        </CCardBody>
      </CCard>
      <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
    </div>
  </template>
  
  <script>
  import BaseTable from "@/views/base/BaseDataTable";
  import ModalConfirm from "@/views/base/BaseModalConfirm";
  import BaseInput from "@/views/base/BaseInput";
  import BaseSwitch from "@/views/base/BaseSwitch";
  import BaseSelect from "@/views/base/BaseSelect2";
  import BaseLoading from "@/views/base/BaseFormLoading";
  
  export default {
    name: "ProductList",
    components: {
      BaseSwitch,
      BaseTable,
      ModalConfirm,
      BaseInput,
      BaseSelect,
      BaseLoading
    },
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success"
      },
      showErrorMsg: {
        type: "error",
        title: "Error"
      },
      showWarningMsg: {
        type: "warn",
        title: "warn"
      }
    },
    data() {
      let that = this;
      let actionTypeMapping = new Map();

      actionTypeMapping.set("delete_one", {
        url: "/product/delete",
        titlePopup: function () {
          return that.$helper.setupTitleAction(
            "xóa",
            "sản phẩm",
            that.actionData.model.code + " - " + that.actionData.model.name
          );
        },
        isJsonContentType: false,
        // type: 'PUT',
        dataSubmit: function () {
          return { id: that.actionData.model.id };
        },
        successCallback: function () {
          that.actionData.model.listSelectedId = [];
          that.showSuccessMsg({ message: "Xóa sản phẩm " + that.actionData.model.code + " - " + that.actionData.model.name + " thành công" });
          that.loadDataMainTable();
        }
      });
  
      actionTypeMapping.set("delete_list", {
        url: "/product/delete-list",
        titlePopup: function () {
          return that.$helper.setupTitleAction("xóa", "các sản phẩm", "đã chọn");
        },
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            lsId: that.actionData.model.listSelectedId
          };
        },
        successCallback: function () {
          that.actionData.model.listSelectedId = [];
          that.showSuccessMsg({ message: "Xóa danh sách sản phẩm thành công" });
          that.loadDataMainTable();
        },
      });
  
      return {
        loading: { value: false },
        labelIcon: {
          labelOn: '\u2713',
          labelOff: '\u2715'
        },
        actionData: {
          actionTypeMapping: actionTypeMapping,
          model: {
            selectedAll: false,
            code: null,
            name: null,
            id: null,
            listSelectedId: []
          }
        },
        codeInput: {
          options: {
            placeholder: "Mã sản phẩm",
            label: 'Mã sản phẩm',
          },
          data: {
            name: "code",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            }
          }
        },
        nameInput: {
          options: {
            placeholder: "Tên sản phẩm",
            label: 'Tên sản phẩm'
          },
          data: {
            name: "name",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            }
          }
        },
        mainTable: {
          options: {
            fields: [
              { key: "checkbox", label: "#", sorter: false, filter: false },
              {key: "createDate", label: "Ngày tạo"},
              { key: "code", label: "Mã sản phẩm" },
              { key: "name", label: "Tên sản phẩm" },
              { key: "cateName", label: "Danh mục sản phẩm" },
              { key: "quantity", label: "Tồn kho" },
              { key: "uomName", label: "ĐVT" },
              { key: "action", label: "Thao tác", sorter: false, filter: false }
            ],
            slots: ["checkbox", "createDate", "action"],
            sorter: true,
            columnFilter: false,
            clickableRows: true,
            hover: false,
            itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
            pageSize: 20,
          },
          dataSource: {
            url: "/product/getPages",
            dataSubmit: function () {
              that.actionData.model.listSelectedId = [];
              return that.$helper.setupDataSubmit(that.$data);
            },
            response: function (dataResponse) {
              return dataResponse.data;
            }
          }
        }
      };
    },
    methods: {
      rowClickTable(value) {
        let targetClick = value.event.target;
        if (value.column === 'action' && ($(targetClick).is("i.fa")) ||
          $(targetClick).is("button") || $(targetClick).is("svg") || $(targetClick).is("path")) {
          return;
        }
        if (value && value.item && value.item.id) {
          if (this.actionData.model.listSelectedId.includes(value.item.id)) {
            const index = this.actionData.model.listSelectedId.indexOf(value.item.id)
            if (index > -1) { // only splice array when item is found
              this.actionData.model.listSelectedId.splice(index, 1); // 2nd parameter means remove one item only
              value.item._classes = 'inactive';
            }
          } else {
            value.item._classes = 'active';
            this.actionData.model.listSelectedId.push(value.item.id);
          }
        }
      },
      loadDataMainTable: function (isUpdateFilter) {
        this.$refs.mainTable.loadData(true, isUpdateFilter);
      },
      changeSelectAll: function (event) {
        // let listSelectedId = this.actionData.model.listSelectedId;
        if (this.actionData.model.selectedAll) {
          this.actionData.model.listSelectedId = [];
  
          this.$refs.mainTable.items.forEach(each => {
            this.actionData.model.listSelectedId.push(each.id);
          });
        } else {
          this.actionData.model.listSelectedId = [];
        }
      },
      setupSelectOneAction: function (actionTypeKey, id, code, name) {
        let actionData = this.actionData.model;
        actionData.code = code || null;
        actionData.name = name || null;
        actionData.id = id || null;
        this.$refs.actionModal.setCurrAction(actionTypeKey);
      },
      checkQuantity: function (item) {
        let that = this;
        this.$helper.loadDataSource({
            loading: that.loading,
            url: "/stock-line/check-quantity-in-stock",
            isJsonContentType: false,
            dataSubmit: function () {
                return { productId: item.id }
            },
            successCallback: function (response) {
                item.quantity = response.data.data;
                that.loading.value = false;
            },
            errorCallback: function (error) {
                that.$helper.handleError(that.$router, error);
                that.loading.value = false;
            }
        });
      }
    },
    created: function () {
    },
    mounted() {
    },
    watch: {
      "actionData.model.listSelectedId": function (newValue) {
        let that = this;
        if (that.$refs.mainTable.items.length > 0 && newValue.length === that.$refs.mainTable.items.length) {
          that.actionData.model.selectedAll = true;
          that.$refs.mainTable.items.map(each => each._classes = 'active');
        } else {
          that.actionData.model.selectedAll = false;
          if (newValue.length == 0) {
            that.$refs.mainTable.items.map(each => each._classes = 'inactive');
          }
        }
      }
    },
    computed: {}
  };
  </script>
  <style scoped>
  .td-roles {
    max-width: 250px;
  }
  
  </style>
  